import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {INSTANT_BOOK__16} from '@homeaway/svg-defs';

const InstantBookIcon = (props) => {
    return (
        <span
            className="InstantBookIcon"
            aria-hidden="true"
            title={props.messages.instantConfirmationSecondaryLabel}
        >
            <SVGIcon markup={INSTANT_BOOK__16} inline />
        </span>
    );
};

export default InstantBookIcon;
